import { useI18n } from '@/hooks/use-i18n'
import { SupportedLanguages } from '@/i18n/config'
import {
  LinkListCountryCode,
  linkListCountryCodesSchema,
} from '@/types/schema/billboard/multi-dimension'
import { countryCodeSchema } from '@/types/schema/country-code-schema'

const useLinkListSortedCountries = (): LinkListCountryCode[] => {
  const { language } = useI18n()

  return ((): LinkListCountryCode[] => {
    const priorityOrders = {
      [SupportedLanguages.zhTW]: [
        countryCodeSchema.enum.tw,
        countryCodeSchema.enum.hk,
      ],
      [SupportedLanguages.ja]: [countryCodeSchema.enum.jp],
      [SupportedLanguages.enUS]: [
        countryCodeSchema.enum.sg,
        countryCodeSchema.enum.my,
      ],
    }

    const priorityOrder = priorityOrders[language.i18nCode] ?? []

    return [...linkListCountryCodesSchema.options].sort((a, b) => {
      const indexA = priorityOrder.indexOf(a)
      const indexB = priorityOrder.indexOf(b)
      return (
        (indexA === -1 ? Infinity : indexA) -
        (indexB === -1 ? Infinity : indexB)
      )
    })
  })()
}

export default useLinkListSortedCountries
